const common = { width: 18, height: 18, viewBox: '0 0 24 24', 'aria-hidden': true } as const;

export const PlayIcon = () => (
  <svg {...common} fill="currentColor"><path d="M8 5.5v13l10.5-6.5z" /></svg>
);
export const PauseIcon = () => (
  <svg {...common} fill="currentColor"><path d="M7 5h3.5v14H7zM13.5 5H17v14h-3.5z" /></svg>
);
export const RestartIcon = () => (
  <svg {...common} fill="none" stroke="currentColor" strokeWidth={2} strokeLinecap="round"><path d="M5 12a7 7 0 1 0 2.1-5" /><path d="M5 4v4h4" /></svg>
);
export const LoopIcon = () => (
  <svg {...common} fill="none" stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round"><path d="M17 7H8a4 4 0 0 0 0 8" /><path d="M7 17h9a4 4 0 0 0 0-8" /><path d="M14 4l3 3-3 3" /></svg>
);
export const FlipIcon = () => (
  <svg {...common} fill="none" stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round"><path d="M4 8h13l-3-3" /><path d="M20 16H7l3 3" /></svg>
);
export const HoldIcon = () => (
  <svg {...common} fill="none" stroke="currentColor" strokeWidth={2} strokeLinecap="round"><path d="M5 12h9" /><path d="M18 6v12" /></svg>
);
export const ArrowLeft = () => (
  <svg {...common} fill="none" stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round"><path d="M15 5l-7 7 7 7" /></svg>
);

/** The wordmark: a gravity well seen from above, a line falling into its centre. */
export const Mark = ({ size = 26 }: { size?: number }) => (
  <svg width={size} height={size} viewBox="0 0 32 32" aria-hidden="true">
    <circle cx="16" cy="16" r="14" fill="none" stroke="currentColor" strokeOpacity="0.28" strokeWidth="1.4" />
    <circle cx="16" cy="16" r="8.5" fill="none" stroke="currentColor" strokeOpacity="0.5" strokeWidth="1.4" />
    <path d="M4.5 9.5 C 11 11, 13.5 13, 16 16" fill="none" stroke="var(--tension)" strokeWidth="2.2" strokeLinecap="round" />
    <circle cx="16" cy="16" r="3" fill="var(--rest)" />
  </svg>
);

const line = { ...common, fill: 'none', stroke: 'currentColor', strokeWidth: 1.8, strokeLinecap: 'round', strokeLinejoin: 'round' } as const;

/** Pieces: a stack of scores. */
export const PiecesIcon = () => (
  <svg {...line}><path d="M6 4h9l3 3v13H6z" /><path d="M9 10h6M9 13h6M9 16h4" /></svg>
);
/** Compare: two lines side by side, one shifted. */
export const CompareIcon = () => (
  <svg {...line}><path d="M4 15c2.5-6 5-6 7.5 0" /><path d="M12.5 15c2.5-6 5-6 7.5 0" /><path d="M4 19h16" /></svg>
);
/** Patterns: a path of three steps. */
export const PatternsIcon = () => (
  <svg {...line}><circle cx="5" cy="7" r="2" /><circle cx="12" cy="12" r="2" /><circle cx="19" cy="17" r="2" /><path d="M6.6 8.2l3.8 2.6M13.6 13.2l3.8 2.6" /></svg>
);
/** Statistics: bars. */
export const StatsIcon = () => (
  <svg {...line}><path d="M5 20V11M10 20V5M15 20v-7M20 20V9" /></svg>
);
/** Play: keys of a keyboard. */
export const KeysIcon = () => (
  <svg {...line}><rect x="3.5" y="5" width="17" height="14" rx="1.5" /><path d="M8 5v14M12 5v14M16 5v14" /><path d="M8 5v8M12 5v8" strokeWidth={3.2} /></svg>
);
export const SlidersIcon = () => (
  <svg {...line}><path d="M4 7h10M18 7h2M4 17h4M12 17h8" /><circle cx="16" cy="7" r="2" /><circle cx="10" cy="17" r="2" /></svg>
);
export const HelpIcon = () => (
  <svg {...line}><circle cx="12" cy="12" r="9" /><path d="M9.6 9.3a2.5 2.5 0 1 1 3.4 2.4c-.7.3-1 .8-1 1.5v.6" /><path d="M12 17h.01" strokeWidth={2.4} /></svg>
);
export const CloseIcon = () => (
  <svg {...line}><path d="M6 6l12 12M18 6L6 18" /></svg>
);
export const SearchIcon = () => (
  <svg {...line}><circle cx="11" cy="11" r="6.5" /><path d="M16 16l4 4" /></svg>
);
